<template>
	<div class="setpsword layui-layout layui-layout-admin" style="background:#fff;padding-bottom: 200px;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> {{showClass==1?'发货地址': showClass==2?'新增发货地址':'编辑发货地址'}}
			</div>
		</div>
		<div v-show="showClass==1">
			<button @click="setClass(2)" type="button" class="layui-btn zt_color" style="margin: 16px 0 16px 5%;">新建发货地址</button>
			<table class="layui-table" id="sites" style="width:90%;margin:0 5%;">
			    <colgroup>
					<col width="150">
					<col width="200">
					<col>
			    </colgroup>
			    <thead>
					<tr>
						<th class="align_center">默认</th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">地址</th>
						<th class="align_center">操作</th>
					</tr>
			    </thead>
			    <tbody>
			        <tr v-for="(item,i) in datas" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center" style="width:40%;">{{item.province+ item.city + item.area + item.address}}</td>
						<td class="align_center">
							<span @click="setTheAddr(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
							<span @click="editTheAddr(item)" class="pointer" style="color:#248aff;margin-left:10px;">编辑</span>
							<span @click="delTheAddr(item)" class="pointer" style="color:rgb(229, 28, 35);margin-left:10px;">删除</span>
						</td>
			        </tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="5">暂无数据</td>
					</tr>
			    </tbody>
			</table>
		</div>
		<!-- 新增地址 -->
		<div v-if="showClass==2">
			<form class="layui-form px16" id="form" action="" style="margin:30px 0px;">
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">姓名</label>
					<div class="layui-input-inline">
						<input type="text" name="names" maxlength="20" required lay-reqText="请输入姓名" lay-verify="required" placeholder="请输入姓名" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">电话</label>
					<div class="layui-input-inline">
						<input type="phone" name="phone" maxlength="11" required lay-reqText="请输入电话" lay-verify="phone" placeholder="请输入电话" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">地址</label>
					<div class="layui-input-inline">
						<select name="province" lay-verify="required" lay-reqText="请选择省份">
							<option value="">省份</option>
							<option v-for="(item,index) in provinceData" :data-i="index" :value="item.provinceName" :key="item.provinceCode">{{item.provinceName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="city" lay-verify="required" lay-reqText="请选择城市">
							<option value="">城市</option>
							<option v-for="(item,index) in cityData" :data-i="index" :value="item.cityName" :key="item.cityCode">{{item.cityName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="area" lay-verify="required" lay-reqText="请选择区域">
							<option value="">区域</option>
							<option v-for="(item,index) in areaData" :data-i="index" :value="item.areaName" :key="item.areaCode">{{item.areaName}}</option>
						</select>
					</div>
					<div class="layui-input-inline" style="min-width:300px;">
						<input type="text" name="addDetail" required lay-verify="required" maxlength="30" lay-reqText="请输入详细地址" placeholder="请输入详细地址" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">默认</label>
					<div class="layui-input-block" style="display: flex;align-items: center;">
						<input type="checkbox" name="switch" lay-skin="switch">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color" lay-submit lay-filter="addAddress" style="width:155px;margin: 20px 0 0 110px;">保存</button>
			</form>
		</div>
		<!-- 编辑地址 -->
		<div class="layer" v-if='edit'></div>
		<div id="edit" style="display: none;">
			<form class="layui-form px16" action="" style="margin:30px 0px;" lay-filter="formTest">
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">姓名</label>
					<div class="layui-input-inline">
						<input type="text" v-model="editName" name="names" maxlength="20" required lay-reqText="请输入姓名" lay-verify="required" placeholder="请输入姓名" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">电话</label>
					<div class="layui-input-inline">
						<input type="phone" v-model="editPhone" name="phone" maxlength="11" required lay-reqText="请输入电话" lay-verify="phone" placeholder="请输入电话" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">地址</label>
					<div class="layui-input-inline">
						<select name="province" lay-verify="required" lay-reqText="请选择省份">
							<option value="">省份</option>
							<option v-for="(item,index) in provinceData" :value="item.provinceName" :key="item.provinceCode">{{item.provinceName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="city" lay-verify="required" lay-reqText="请选择城市">
							<option value="">城市</option>
							<option v-for="(item,index) in cityData" :value="item.cityName" :key="item.cityCode">{{item.cityName}}</option>
						</select>
					</div>
					<div class="layui-input-inline">
						<select name="area" lay-verify="required" lay-reqText="请选择区域">
							<option value="">区域</option>
							<option v-for="(item,index) in areaData" :value="item.areaName" :key="item.areaCode">{{item.areaName}}</option>
						</select>
					</div>
					<div class="layui-input-inline" style="min-width:300px;">
						<input type="text" v-model="editAddr" name="addDetail" maxlength="30" required lay-verify="required" lay-reqText="请输入详细地址" placeholder="请输入详细地址" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label align_right pr_20">默认</label>
					<div class="layui-input-block" style="display: flex;align-items: center;">
						<input type="checkbox" name="switch" lay-skin="switch">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color" lay-submit lay-filter="save" style="width:155px;margin: 20px 0 0 110px;">保存</button>
			</form>
		</div>
	</div>
</template>

<script>
	import city from "@/utils/city.js";
	export default {
		name: 'sites',
		data() {
			return {
				showClass: 1,
				forms: '',
				province: 0,
				province2: 0,
				city: 0,
				city2: 0,
				area: 0,
				datas: [],
				provinceData: [],
				cityData: [],
				areaData: [],
				edit: false,
				editName: '',
				editPhone: '',
				editAddr: '',
				editDefault: ''
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['form', 'layer', 'table'], () => {
				_this.forms = layui.form;
				let layer = layui.layer;
				let table = layui.table;
				_this.forms.on('submit(addAddress)', function(data) { //监听提交
					let is_default = 0;
					if(data.field.switch) {
						is_default = 1;
					}
					api.addAddress({
						token: _this.getCookie('token'),
						name: data.field.names,
						mobile: data.field.phone,
						province: data.field.province,
						city: data.field.city,
						area: data.field.area,
						address: data.field.addDetail,
						is_default: is_default,
					}).then((res) => {
						if(res.code == 1) {
							layer.msg('添加成功', {
								icon: 1,
								anim: 5
							})
							_this.provinceData = [];
							_this.cityData = [];
							_this.areaData = [];
							_this.forms.render('select');
							document.getElementById("form").reset()
							_this.forms.render();
							_this.getData();
							_this.showClass = 1;
						}
					})
					return false;
				});
				_this.forms.on('select()', function(e) { //监听下拉框
					let index = e.elem.selectedIndex - 1;
					index = index < 0 ? 0 : index;
					if(e.elem.name == 'province') {
						_this.cityData = _this.provinceData[index].mallCityList;
						_this.areaData = [];
					} else if(e.elem.name == 'city') {
						_this.areaData = _this.cityData[index].mallAreaList;
					}
					setTimeout(function() {
						_this.forms.render('select');
					}, 100);
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				api.getAddressList({
					token: this.getCookie('token')
				}).then((res) => {
					_this.datas = res.data;
				})
			},
			setTheAddr(item) {
				let _this = this;
				api.setDefaultAddress({
					token: _this.getCookie('token'),
					id: item.id,
				}).then((res) => {
					if(res.code == 1) {
						_this.getData();
					} 
				})
			},
			editTheAddr(item) {
				let _this = this;
				this.cityData = [];
				this.areaData = [];
				this.provinceData = city.city;
								
				this.edit = true;
				this.editName = item.name;
				this.editPhone = item.mobile;
				this.editAddr = item.address;
				for(let i = 0; i < this.provinceData.length; i++) {
					if(item.province == this.provinceData[i].provinceName) {
						this.cityData = this.provinceData[i].mallCityList;
						for(let j = 0; j < this.cityData.length; j++) {
							if(item.city == this.cityData[j].cityName) {
								this.areaData = this.cityData[j].mallAreaList;
								break
							}
						}
						break
					}
				}
				layui.use(['form', 'layer', 'table'], () => {
					var form = layui.form;
					setTimeout(() => {
						layer.open({
							title: '编辑',
							type: 1,
							content: $('#edit'),
							area: ['1200px', '600px'],
							shade: 0,
							success: function() {
								form.val("formTest", {
									"province": item.province,
									"city": item.city,
									"area": item.area,
									"switch": item.is_default,
								});
								form.render('select', 'formTest');
							},
							cancel: function(index, layero) {
								_this.edit = false
							}
						});
					}, 100)
					form.on('submit(save)', function(data) { //监听提交
						let is_default = 0;
						if(data.field.switch) {
							is_default = 1;
						}
						api.editAddress({
							token: _this.getCookie('token'),
							id: item.id,
							name: data.field.names,
							mobile: data.field.phone,
							province: data.field.province,
							city: data.field.city,
							area: data.field.area,
							address: data.field.addDetail,
							is_default: is_default,
						}).then((res) => {
							if(res.code == 1) {
								layer.msg('保存成功', {
									icon: 1,
									anim: 5
								})
								form.render();
								_this.getData();
								_this.edit = false;
								layer.closeAll();
							}
						})
						return false;
					});
					form.on('select()', function(e) { //监听下拉框
						let index = e.elem.selectedIndex - 1;
						index = index < 0 ? 0 : index;
						if(e.elem.name == 'province') {
							_this.cityData = _this.provinceData[index].mallCityList;
							_this.areaData = [];
						} else if(e.elem.name == 'city') {
							_this.areaData = _this.cityData[index].mallAreaList;
						}
						setTimeout(function() {
							_this.forms.render('select');
						}, 100);
					});
				});
			},
			delTheAddr(item) {
				let _this = this;
				layui.use(['layer'], () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						content: '是否需确认删除该地址？',
						btn: ['确认', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							api.delAddress({
								token: _this.getCookie('token'),
								id: item.id,
							}).then((res) => {
								layer.msg('删除成功', {
									icon: 1,
									anim: 5
								})
								_this.getData();
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				});
			},
			setClass(e) {
				this.showClass = e;
				if(e == 2) {
					let _this = this;
					this.cityData = [];
					this.areaData = [];
					this.provinceData = city.city;
					setTimeout(function() {
						_this.forms.render();
					}, 10);
				}
			},
		}
	}
</script>

<style scoped>
	.layui-header {
		z-index: 0;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 3;
	}
</style>



// WEBPACK FOOTER //
// src/components/sites.vue